import styled from 'styled-components';

export const MobileDropdown = styled.div`
  display: ${props => props.isOpen ? 'flex' : 'none'};
  flex-direction: column;
  position: absolute;
  width: 100%;
  background: #fff;
  margin-top: -3%;
  
  a {
    padding: 16px 24px 16px 0;
    border: 1px solid #e3e3e3;
    border-top: none;
    text-align: end;
    text-decoration: none;
    font-family: Cabin-Bold, sans-serif;
    color: #737373;
    //font-size: 16px;
    
    :hover {
      background: #d7eef5;
      color: #15538c;
    }
    
    :first-child {
      border-top: 1px solid #e3e3e3;
    }
  }
  
  @media (min-width: 768px) {
    display: none;
  }
`;

export const Dropdown = MobileDropdown.extend`
  display: none;
  right: 0;
  top: 60%;
  padding-top: 35px; 
  margin-top: 1px;

   @media (min-width: 768px) {
    display: ${props => props.isOpen ? 'flex' : 'none'};
    width: 250px;
  }
  
  @media(min-width: 992px){
    width: 300px;
  }
  
  @media(min-width: 1680px){
    width: 340px;
  }
  
  div {
    padding: 16px 24px 16px 0;
    border: 1px solid #e3e3e3;
    border-top: none;
    text-align: end;
    text-decoration: none;
    font-family: Cabin-Bold, sans-serif;
    color: #737373;
    
    :hover {
      background: #d7eef5;
      color: #15538c;
    }
  }
`;


// WEBPACK FOOTER //
// ./src/components/Dropdown/Dropdown.js